import InvoicesTable from 'pages/invoices/InvoicesTable';
import { useDefaultInvoiceTabKey } from 'pages/invoices/util/useDefaultInvoiceTabKey';
import { useValidInvoiceTab } from 'pages/invoices/util/useValidInvoiceTab';
import MatterNewInvoiceButton from 'pages/matters/invoices/MatterNewInvoiceButton';
import MatterNewPrepaymentButton from 'pages/matters/invoices/MatterNewPrepaymentButton';
import { Navigate, useParams } from 'react-router-dom';

interface Props {
    matterId?: string;
}

const InvoiceView: React.FC<Props> = ({ matterId }) => {
    const { invoiceTab } = useParams<{ invoiceTab?: string }>();
    const isValidTab = useValidInvoiceTab(invoiceTab);
    const defaultTabKey = useDefaultInvoiceTabKey();

    if (!matterId || !isValidTab) {
        return null;
    }

    // No `:invoiceTab` segment yet → redirect to the last-selected (or default) sub-tab so the
    // active tab is always reflected in the URL and restored across visits, mirroring the global
    // invoices list.
    if (invoiceTab === undefined) {
        return <Navigate to={`/matter/${matterId}/invoices/${defaultTabKey}`} replace />;
    }

    return (
        <div className="flex flex-col gap-4">
            <InvoicesTable
                key={invoiceTab}
                passiveFilter={`id=ismatterinvoice=${matterId}`}
                defaultShowTotals
                disabledGroups={['invoices.filter.case-group', 'invoices.filter.client-group']}
                matterId={matterId}
                pathBasedTabId={invoiceTab}
                extraHeaderComponent={
                    <div className="flex justify-end gap-2.5">
                        <MatterNewPrepaymentButton matterId={matterId} />
                        <MatterNewInvoiceButton matterId={matterId} />
                    </div>
                }
            />
        </div>
    );
};

export default InvoiceView;
